import { Component, OnInit, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';
import echarts from 'echarts';
import { formatNumber } from '../../../../shared/utils/common';

@Component({
  selector: 'app-fans-age',
  templateUrl: './fans-age.component.html',
  styleUrls: ['./fans-age.component.less'],
})
export class FansAgeComponent implements OnInit, OnChanges {
  constructor(private el: ElementRef) {
    /* this.data = mockFansAgeData; */
  }

static NAME = 'icc-msg-social-fans-age';

  // 图谱实例
  chartIns: any;

  // 展示数据
  ageList: Array<string> = [];
  countList: Array<number> = [];

  // 数据源
  @Input() data: Array<{
    item: string; // 年龄段
    value: number; // 粉丝数量
  }>;

  // 排名列表
  rankList: Array<{
    name: string; // 年龄段
    value: string; // 粉丝数
    ratio: string; // 占比
  }>;

  // 自适应函数
  resizeCharts = () => {
    if (this.chartIns) {
      this.chartIns.resize();
    }
  };

  ngOnInit() {
    window.addEventListener('resize', this.resizeCharts);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.data instanceof Array) {
      this.ageList = [];
      this.countList = [];
      this.data.forEach(item => {
        this.ageList.push(item.item);
        this.countList.push(item.value);
      });
      this.formatPieData(this.data);
      this.rankList = [];
      this.getRank();
      setTimeout(() => {
        this.createLineChart('chart-el');
      }, 100);
    }
  }

  ngOnDestroy() {
    if (this.chartIns) {
      this.chartIns.dispose();
      this.chartIns = null;
    }
    window.removeEventListener('resize', this.resizeCharts);
  }

  // 数据处理
  formatPieData(data) {
    const result = [];
    let sub = 0;
    data.forEach((item: any) => {
      sub = sub + item.value;
    });
    data.forEach((item: any) => {
      const temp: any = {};
      temp.name = item.item;
      temp.value = formatNumber(item.value);
      const radioBefore = item.value===0 ? 0: Number((item.value / sub).toFixed(2)) * 100;
      temp.ratio = radioBefore.toFixed(0) + '%';
      result.push(temp);
    });
    return result;
  }

  // 获取粉丝数量前五名
  getRank() {
    let tempData = this.data.sort((a, b) => b.value - a.value);
    this.rankList = this.formatPieData(tempData).splice(0, 5);
  }

  /* 生成图谱 */
  createLineChart(chartCls) {
    const elCollection = this.el.nativeElement.getElementsByClassName(chartCls);
    if (!this.chartIns && elCollection.length) {
      this.chartIns = echarts.init(elCollection[0]);
    }
    const axisLabel: any = {
      textStyle: {
        color: '#B9C0D6',
      },
      formatter: '{value} ',
      margin: 20,
    };
    if (this.data.length >= 10) {
      axisLabel.margin = 10;
      axisLabel.interval = 0;
      axisLabel.rotate = 0;
    }
    this.chartIns.setOption({
      tooltip: {
        trigger: 'axis',
        backgroundColor: 'rgba(0,0,0,0.6)',
      },
      legend: {
        show: false,
      },
      grid: {
        x: '8%',
        width: '82%',
        y: '12%',
        top: '20%',
      },
      xAxis: [
        {
          data: this.ageList,
          boundaryGap: true,
          axisLine: {
            lineStyle: {
              color: '#eee',
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel,
        },
      ],
      yAxis: [
        {
          name: '单位:个',
          nameTextStyle: {
            padding: [3, 4, 5, 6],
            color: '#B9C0D6',
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#eee',
            },
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#eee',
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              color: '#B9C0D6',
            },
            formatter: '{value} ',
          },
        },
        {
          axisLine: {
            show: true,
            lineStyle: {
              color: '#eee',
            },
          },
        },
      ],
      series: [
        {
          name: '粉丝数',
          type: 'bar',
          symbolSize: 1,
          barWidth: 40, // 柱体宽度
          itemStyle: {
            normal: {
              color: 'rgb(0,206,158)',
            },
          },
          data: this.countList,
        },
      ],
    });
  }
}
